import React from "react";
import { secondsToTime } from "../../../utility/formatter";
import { OTP_RESEND_INTERVAL } from "../../../utility/constants";
import "./Timer.scss";
import PropTypes from "prop-types";

Timer.propTypes = {
  handleResendOTP: PropTypes.func.isRequired
};

export default function Timer({ handleResendOTP }) {
  const [counter, setCounter] = React.useState(OTP_RESEND_INTERVAL);
  React.useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  return (
    <div className="timer">
    <div className="t-ryt">
     
    { !counter ?(
    <p>
    Didn’t receive code? 
    <button
    type="button"
    onClick={e => {
      setCounter(OTP_RESEND_INTERVAL);
      handleResendOTP(e);
    }}
    className="btn-resend"
  >
    Resend OTP
  </button>
  </p>):(
      <p></p>
      )}
      {counter ? (
        <span>
        Time Remaining: <b>{secondsToTime(counter)}</b>
        </span>
      ) : (
        ""
      )}
    </div>
    </div>
  );
}
